import { Characteristic,  } from './Characteristic';

export class CharacteristicScore {
    public id: number;
    public scoreTypeID: number;
    public highScore?: number;
    public lowScore?: number;
    public characteristicID: number;
    public characteristic: Characteristic;
}


// WEBPACK FOOTER //
// ./src/models/CharacteristicScore.tsx